<template>
    <Form ref="form" @submit="onNextPage" :validation-schema="schema" v-slot="{ errors }">
        <div class="form-section">
            <p class="c2 is-uppercase has-text-weight-medium is-size-5 mt-5 mb-5">SİZİN BİLGİLERİNİZ</p>
            <div class="columns is-variable is-5 is-multiline">
                <div :class="['column', { 'is-half': type === 0 }, {'is-full': type === 1}]">
                    <div class="field">
                        <div class="control">
                            <Field name="owner_name_surname" class="input" type="text" placeholder="İsminiz ve Soyisminiz*" 
                            :class="{'is-danger': errors.owner_name_surname }"/>
                        </div>
                    </div>
                </div>
                <div class="column is-half">
                    <div class="field">
                        <div class="control">
                            <Field name="owner_email" class="input" type="email" placeholder="E-posta Adresiniz*"
                            :class="{'is-danger': errors.owner_email }"/>
                        </div>
                    </div>
                </div>
                <div class="column is-half">
                    <div class="field">
                        <div class="control">
                            <Field name="owner_phone" type="tel" class="input" placeholder="Telefon numaranız"
                            :class="{'is-danger': errors.owner_phone }"/>
                        </div>
                    </div>
                </div>
                <div v-if="type === 0" class="column is-half">
                    <div class="field">
                        <div class="control">
                            <Field name="owner_relation" class="input" type="text" placeholder="Yakınlığınız"
                            :class="{'is-danger': errors.owner_relation }"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <p class="c2 is-uppercase has-text-weight-medium is-size-5 mt-5 mb-5">İZİNLER</p>
        <div class="rows">
            <div class="row">
                <label class="checkbox">
                    <input @change="(e)=>{isClarificationChecked = e.target.checked; clarificationChanged = true;}" ref="clarification" type="checkbox" style="max-height: 0.8rem;"/>
                </label>
                <p class="info" :class="{'has-text-danger': !isClarificationChecked && clarificationChanged }" style="display: inline-block; padding-left: 1rem"><a @click="showLetterOfClarification = true;" class="is-underlined">Aydınlatma metnini</a> okudum ve onaylıyorum.</p>

            </div>
            <div class="row mt-1">
                <label class="checkbox">
                    <input @change="(e)=>{isConsentChecked = e.target.checked; consentChanged = true;}" ref="consent" type="checkbox" style="max-height: 0.8rem;"/>
                </label>
                <p class="info" :class="{'has-text-danger': !isConsentChecked && consentChanged }" style="display: inline-block; padding-left: 1rem">www.6subat.hafizasi.com internet sitesinin verilerimi saklaması ve transfer etmesine <a @click="showExpressConsent = true;" class="is-underlined">açık rıza</a> veriyorum.</p>
            </div>
        </div>

        <div class="columns mt-5 is-centered">
            <div class="column mt-5 mb-5 is-three-fifths">
                <div class="columns">
                    <div class="column is-one-thirds">
                        <button type="button" @click="onPreviousPage" class="button secondary"><p class="is-uppercase">Geri Git</p></button>
                    </div>
                    <div class="column is-two-thirds">
                        <button type="submit" class="button primary"><p class="c3 is-uppercase">Bellek Oluştur</p></button>
                    </div>
                </div>
            </div>
        </div>
    </Form>

    <div v-if="showLetterOfClarification" id="letterOfClarificationModal" class="modal" style="display:flex;">
        <div @click="showLetterOfClarification=false;" class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title c2 is-uppercase has-text-weight-medium is-size-5 mt-5 mb-5">Aydınlatma Metni</p>
                <button @click="showLetterOfClarification=false;" class="delete is-large" aria-label="close"></button>
            </header>
            <section class="modal-card-body">
                <p class="info" style="white-space: pre-wrap;">
                    www.6subat.hafizasi.com (Bundan böyle “İnternet Sitesi” olarak anılacaktır.) isimli internet sitesi deprem sonrası kişilerin lokasyonu veya akıbeti ile ilgili haber alamadığı  aile bireyleri veya yakınları ile ilgili bilgi paylaşabileceği ve konu hakkında bilgisi olan kişi veya kurumların onlara ulaşmasına yardımcı olmayı hedefleyen bir duyuru platformudur.<br><br>Bu doğrultuda, İnternet Sitesi’nde üyeleri tarafından verilen bilgilerin nasıl kullanıldığı ve paylaşıldığının üyeleri için ne kadar önemli olduğunun sorumluluğu ve bilincinde olup, bilgilerin gizliliğini korumak amacıyla aşağıda belirtilen temel kuralları benimsemektedir. <br><br>Kişiler, İnternet Sitesi’ne, sitenin talebi olmaksızın yakınları hakkında bazı kişisel bilgileri (ad, soyad, telefon numarası, e-posta adresi, adres vb.) yükleyebilirler. Sitenin esasen bu şekilde bir talebi bulunmamaktadır. Siteye bu içerikte bilgilerin eklenmesi halinde kişiler, Kişisel Verilerin Korunması Kanunu’nun 5.maddesinin 2.fıkrasının b bendi uyarınca işlem yapmakta olduklarını kabul, beyan ve taahhüt ederler.<br><br>Aksi belirtilmediği takdirde, mevcut gizlilik politikamız siz ve hesabınızla ilgili olarak kendi isteğiniz ile sisteme kaydettirdiğiniz bütün bilgiler için geçerlidir. Üyeler, İnternet Sitesi’nde bir Kullanıcı profili oluşturarak ve İnternet Sitesi’ne kendi kişisel bilgileri ile kayıt yaptırarak işbu gizlilik politikasını ve gizlilik sözleşmesini kabul etmiş sayılırlar. <br><br>Üyeler tarafından İnternet Sitesi’nde paylaşılmış olan kişisel veya söz konusu yakınları ile ilgili bilgiler sadece haber alınamayan kişiyle ilgili bilgi paylaşmak istendiğinde veya iletişim ihtiyacı doğduğunda kullanılacaktır.  <br><br>İnternet Sitesi, kullanıcılarının kendi verileri ile gizliliklerini korumakla yükümlüdür. İnternet Sitesi’ne girilen bilgilerin güvenliğinin sağlanabilmesi açısından sistem ve internet altyapısını en güvenilir seviyede tutarak gerekli önlemleri almıştır. Bu sorumluluk, internet ortamının gerektirdiği koşullar içerisinde sağlanan en üst düzey gizliliği içermekte olup, internet ortamında hiçbir zaman tam güvenliğin sağlanamadığı da bilinmesi gerekli hususlar içerisindedir. İnternet Sitesi kullanıcılarının gizlilik haklarına saygı duyar ve kullanıcının site vasıtasıyla sağladığı tüm bilgileri saklı tutar. Bununla birlikte İnternet Sitesi üçüncü şahısların yasal ya da yasal olmayan davranışlarının herhangi bir kişi veya kuruma verebileceği hasarlardan sorumlu tutulamaz. <br><br>Söz konusu bilgileri üyelerin onayı ya da aksi bir talimatı olmaksızın ya da yasal bir yükümlülük altında bulunmadığı sürece herhangi bir üçüncü şahıs, kurum ve/veya kuruluş ile paylaşmayacaktır. <br><br>Bu bilgileri sadece gerekli yetkiler ve yasal düzenlemeler çerçevesinde açıklayabilecek olup, internet yasasına tabi olduğu düzenleyici mevzuat, yetkili kurumlar ve/veya yasama, yürütme, yargı organ ve mercileri üye bilgilerinin açıklanmasını istediğinde, bu bilgileri yalnızca gerekli yetkiler çerçevesinde açıklayabilecektir. Yasal bir yükümlülük altında bulunulmadığı sürece bu bilgiler üçüncü şahıslarla kesinlikle paylaşılmayacak, faaliyet dışı hiçbir nedenle ticari vb. nitelikteki amaçla kullanılmayacak ve satılmayacaktır. <br><br>İnternet Sitesi’nin geliştirilmesi ve desteklenmesi maksadıyla destek hizmetler almak amacıyla farklı kuruluşlarla çalışılması durumunda, bu firmaların gizlilik standartlarına ve şartlarına uymalarını sağlayacaktır. <br><br>İnternet Sitesi, diğer internet sitelerine bağlantı vermemektedir. Gizlilik Politikamız'da yer alan taahhütlerimiz sadece İnternet Sitesi içerisinde geçerlidir ve diğer internet sitelerini kapsamamaktadır. İnternet Sitesi’nden bağlantı ile gidilecek diğer internet sitelerindeki kullanım ile ilgili o sitelere ait gizlilik güvencesi ve kullanım şartları geçerlidir. İnternet Sitesi’nden reklam, banner, içerik maksatlı veya başka bir maksat ile geçilen diğer internet sitelerinin bilgi kullanımı, etik ilkeleri, gizlilik prensipleri, nitelik ve servis kalitesi ile bu sitelerde oluşabilecek herhangi bir maddi / manevi zarar ve kayıplardan internet sitesi sorumlu değildir. <br><br>İnternet Sitesi’nde ve İnternet Sitesi’nde yer alan bilgi, materyal ve bunların düzenlenmesi konusundaki telif hakları kullanıcılara aittir. İnternet Sitesi’nin içerdiği üçüncü şahıslara ait materyaller dışında kalan diğer bilgi ve materyallere dair tüm telif hakları, tescilli marka, patent, entelektüel ve diğer mülkiyet hakları internet sitesine aittir. <br><br>Kullanıcıların internet sitesi ile paylaştığı bilgiler, sosyal yardımlaşma, duyuru faaliyetinin yürütülmesinde ve İnternet Sitesi’nde yer alan uygulamaların yenilenmesi durumunda bilgilendirme yapmak amacıyla kullanılabilecektir. <br><br>Üyelerin kişisel bilgilerinin gizliliğini korumak amacıyla sistem ve internet altyapısı en güvenilir seviyede tutularak gerekli önlemler alınmıştır. Ek olarak bilgi alınmak istenen konularda İnternet Sitemiz’den bize ulaşabilirsiniz. <br><br>Gönderim listesinden çıkmak için İnternet Sitemiz’den bize ulaşabilir veya bilgilendirme maillerinin alt kısmında bulunan “Bilgilendirme e-postalarını almak istemiyorsanız lütfen tıklayınız” cümlesinin üzerine tıklayarak talebinizi sisteme otomatik kayıt ile iletebilirsiniz. <br><br>Bize olan güveniniz için teşekkür ederiz. <br><br>Saygılarımızla, 
                </p>

            </section>
            <footer class="modal-card-foot">
                <!-- <button class="button is-success">Save changes</button>
                <button class="button">Cancel</button> -->
            </footer>
        </div>
    </div>

    <div v-if="showExpressConsent" id="expressContentModal" class="modal" style="display:flex;">
        <div @click="showExpressConsent=false;" class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title c2 is-uppercase has-text-weight-medium is-size-5 mt-5 mb-5">Açık Rıza Onayı</p>
                <button @click="showExpressConsent=false;" class="delete is-large" aria-label="close"></button>
            </header>
            <section class="modal-card-body">
                <p class="info" style="white-space: pre-wrap;">
                    www.6subat.hafizasi.com internet sitesine girmiş olduğum tüm verileri özgür irademle doldurduğumu, yukarıdaki ilişkili Aydınlatma Metninde belirtilen amaçların gerçekleştirilebilmesi adına kişisel verilerimin ve yakınlarıma ait verilerin internet sitesi tarafından işlenmesini ve yurt içinde ve yurt dışında bulunan proje paydaşları ve hizmet sağlayıcıları ile paylaşılmasını kabul ediyorum.
                </p>

            </section>
            <footer class="modal-card-foot">
                <!-- <button class="button is-success">Save changes</button>
                <button class="button">Cancel</button> -->
            </footer>
        </div>
    </div>
</template>

<script>
import { Form, Field } from 'vee-validate';
import * as yup from 'yup';

export default {
    props: {
        type: Number
    },
    data() {
        return {
            showLetterOfClarification: false,
            showExpressConsent: false,

            isClarificationChecked: false,
            isConsentChecked: false,

            clarificationChanged: false,
            consentChanged: false,
        }
    },
    emits: ["previousPage, nextPage"],
    setup(props) {
        // const phoneRegExp = /^(05)([0-9]{2})\s?([0-9]{3})\s?([0-9]{2})\s?([0-9]{2})$/ // TR
        const phoneRegExp = /(^$)|(^\+?[0-9]{10,15})$/ // Worldwide
        
        let schema = null;
        if(props.type === 0){
            schema = yup.object({
                owner_name_surname: yup.string().required().max(100).matches(/^[a-zA-ZğüşöçıİĞÜŞÖÇ]+(([',. -][a-zA-ZğüşöçıİĞÜŞÖÇ ])?[a-zA-ZğüşöçıİĞÜŞÖÇ]*)*$/u),
                owner_phone: yup.string().matches(phoneRegExp).max(15),
                owner_email: yup.string().email().required().max(100).matches(/[^\s*].*[^\s*]/g),
                owner_relation: yup.string().max(100),
                // clarification: yup.boolean().required().oneOf([true]),
                // consent: yup.boolean().required().oneOf([true])
                // consent: yup.test('test-name', 'fail',
                //     (value) => {
                //         console.log("v", value);
                //         if (value && value.length) {
                //             return true;
                //         }

                //         return 'You must choose a drink';
                //     },
                // )
            })
        } else {
            schema = yup.object({
                owner_name_surname: yup.string().required().max(100).matches(/[^\s*].*[^\s*]/g),
                owner_phone: yup.string().matches(phoneRegExp).max(15),
                owner_email: yup.string().email().required().max(100).matches(/[^\s*].*[^\s*]/g),
            })
        }
        
        return { schema }
    },
    components: {
        Form, Field
    },
    methods: {
        onPreviousPage(){
            this.$emit('previousPage');
        },

        onNextPage(values){
            if(!this.isClarificationChecked || !this.isConsentChecked){
                return;
            }

            values["type"] = this.$props.type;
            this.$emit('nextPage', values);
        },

        validate(){
            this.$refs.form.validate();
        }
    },
    mounted() {
        // for (const input of [this.$refs.clarification.$el, this.$refs.consent.$el])  {
        //     if (input.type == 'checkbox')   {
        //         input.checked = false;
        //     }
        // }
    }


}
</script>

<style lang="scss" scoped>
    #expressContentModal .modal-card-body {
        @include from($desktop){
            max-height: 20vh;
        }
    }
</style>